import React, { useState } from 'react';

const SearchPanel = ({ show, setShow, aladinInstance }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    if (!aladinInstance.current || !searchQuery.trim()) return;

    try {
      const query = searchQuery.trim();
      
      // Check if input looks like coordinates (contains space and numbers)
      const coordMatch = query.match(/^(-?\d+\.?\d*)\s+(-?\d+\.?\d*)$/);
      
      if (coordMatch) {
        // Parse as RA Dec coordinates
        const ra = parseFloat(coordMatch[1]);
        const dec = parseFloat(coordMatch[2]);
        if (!isNaN(ra) && !isNaN(dec)) {
          aladinInstance.current.gotoRaDec(ra, dec);
        }
      } else {
        // Treat as object name
        aladinInstance.current.gotoObject(query);
      }
    } catch (e) {
      console.error('Search error:', e);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  if (!show) return null;

  return (
    <div className="absolute bottom-8 left-8 z-40 w-80 bg-ui-light-card/80 dark:bg-ui-dark-card/80 backdrop-blur-sm border border-ui-light-border/50 dark:border-ui-dark-border/50 rounded-lg shadow-lg text-ui-light-text-primary dark:text-ui-dark-text-primary transition-all duration-300">
      <div className="p-4">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-5 h-5 bg-primary-100/70 dark:bg-primary-900/50 rounded-md flex items-center justify-center flex-shrink-0">
            <svg className="w-3 h-3 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-medium text-ui-light-text-primary dark:text-ui-dark-text-primary">Search Sky</h3>
        </div>
        
        <input
          type="text"
          placeholder="Object name or RA Dec (e.g., M31 or 10.68 41.27)"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          className="w-full p-3 bg-ui-light-background/70 dark:bg-ui-dark-background/70 backdrop-blur-sm border border-ui-light-border/50 dark:border-ui-dark-border/50 rounded-lg text-ui-light-text-primary dark:text-ui-dark-text-primary placeholder-ui-light-text-tertiary/80 dark:placeholder-ui-dark-text-tertiary/80 focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500/50 focus:bg-ui-light-background dark:focus:bg-ui-dark-background transition-all duration-200 text-sm"
        />
        
        <p className="text-xs text-ui-light-text-tertiary/80 dark:text-ui-dark-text-tertiary/80 mt-2">
          Press Enter to search • Examples: M31, NGC4594, Vega, 10.68 41.27
        </p>
      </div>
    </div>
  );
};

export default SearchPanel;